import type { ReactNode } from "react";
import { InflowLogo } from "@/components/InflowLogo";
import { useTopInset } from "@/lib/useTopInset";

/**
 * ЄДИНА шапка для ВСІХ сторінок поза Layout (Promo, Support, SearchModal…).
 *
 * РОЗТАШУВАННЯ 1:1 з головною сторінкою (юзер 2026-06-10: «логотип — там
 * само, де на головній, на КОЖНІЙ сторінці; де на головній Профіль — там
 * Назад/Меню»):
 *   - Головна (у Layout, edge-to-edge): контейнер має paddingTop = topInset,
 *     а сам хедер — pt-5 (20px). Тобто лого стоїть на `topInset + 20`.
 *   - Тут робимо ТОЧНО ТАК САМО: paddingTop = topInset + 20. Один topInset
 *     (contentSafeAreaInset Telegram) — той самий, що використовує Layout,
 *     тож позиція збігається з головною піксель-в-піксель.
 *   - Логотип ЗЛІВА; права кнопка (Назад / Меню) — у слоті `right`, СПРАВА
 *     (на місці кнопки «Профіль» головної).
 *
 * Якщо колись треба зсунути — міняємо ОДНЕ число TOP_OFFSET_PX тут.
 */
const TOP_OFFSET_PX = 20; // = pt-5 головної (над ним Layout додає topInset)

export function StandaloneHeader({ right }: { right?: ReactNode }) {
  const topInset = useTopInset();
  return (
    <div
      className="relative z-[1] flex items-center justify-between px-5 pb-2"
      style={{ paddingTop: topInset + TOP_OFFSET_PX }}
    >
      <InflowLogo size={18} />
      {right ?? <span />}
    </div>
  );
}
